import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  stroke: "#333",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "clip-path": "url(#a)"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5.25 12a6.75 6.75 0 1 0 13.5 0 6.75 6.75 0 0 0-13.5 0ZM12 2.25V.75M18.894 5.106l1.06-1.061M21.75 12h1.5M18.894 18.894l1.06 1.061M12 21.75v1.5M5.106 18.894l-1.061 1.061M2.25 12H.75M5.106 5.106 4.045 4.045" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }